<template>
  <el-dialog
    class="detail"
    title="查看物流"
    :visible.sync="showDialog"
    width="980px"
  >
    <div class="delivery-empty" v-if="list.length == 0">
      <img
        class="delivery-empty_img"
        src="@/assets/images/order/delivery-empty@2x.png"
      />
      <div class="delivery-empty_text">未查询到结果，请稍后再试</div>
    </div>
    <el-timeline v-else class="delivery-timeline">
      <el-timeline-item
        v-for="(item, index) in list"
        :key="index"
        :class="'delivery-timeline-' + index"
      >
        <div class="delivery-item">
          <div class="delivery-time">
            <span class="status">{{ item.status }}</span>
            <span>{{ item.time }}</span>
          </div>
          <div>
            {{ item.context }}
          </div>
        </div>
      </el-timeline-item>
    </el-timeline>
  </el-dialog>
</template>
<script>
export default {
  name: "MemberOrderDelivery",
  props: {
    visible: Boolean,
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      showDialog: false,
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.showDialog = val;
      },
    },
    showDialog(val) {
      this.$emit("update:visible", val);
    },
  },
  methods: {
    show() {},
  },
};
</script>
<style lang="scss" scoped>
.delivery-timeline {
  /deep/ {
    .el-timeline-item__tail {
      border-left: 1px solid #e6e6e6;
    }
    .el-timeline-item__node--normal {
      width: 8px;
      height: 8px;
      left: 0;
    }
    .el-timeline-item__wrapper {
      padding-left: 36px;
    }
    .el-timeline-item__timestamp {
      display: none;
    }
  }
}
.delivery-timeline-0 {
  /deep/ {
    .el-timeline-item__node--normal {
      &::before {
        content: "";
        position: absolute;
        width: 8px;
        height: 8px;
        background: #ef811e;
        border-radius: 50%;
        z-index: 1;
      }
      &::after {
        content: "";
        position: absolute;
        width: 16px;
        height: 16px;
        background: #fff4eb;
        border-radius: 50%;
      }
    }
  }
}
.delivery-item {
  color: #999999;
  .status {
    font-weight: bold;
    color: #333;
    margin-right: 10px;
  }
}
.delivery-time {
  margin-bottom: 8px;
}
.detail {
  /deep/ {
    .el-dialog__header {
      padding-left: 24px;
      padding-right: 24px;
    }
    .el-dialog__body {
      padding-left: 28px;
      padding-right: 28px;
    }
  }
}
.delivery-empty {
  margin: 126px 0 202px 0;
  position: relative;
}
.delivery-empty_img {
  width: 320px;
  height: 202px;
  display: block;
  margin: 0 auto;
}
.delivery-empty_text {
  position: absolute;
  text-align: center;
  width: 100%;
  color: #666666;
  bottom: 20px;
}
</style>
